module.exports = __webpack_public_path__ + "img/wards.75bc763e.png";